import React, { FC } from 'react';
import cls from './MonthModeCharter.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { CharterItem } from '../../../../../../UI/CharterItem/CharterItem';

export const MonthItemCharter = ({ charter, month, isPlanFact }) => {
    const charterDate = moment(charter.planned.start_date).format('DD.MM.YYYY');

    const nowDate = moment().format('DD.MM.YYYY');

    const isRenderDays =
        month.date === moment(charter.planned.start_date).format('MM.YYYY') ||
        month.date === moment().format('MM.YYYY');

    return (
        <div
            className={classNames(cls.month, { [cls.factWrapper]: isPlanFact })}
            style={{ width: 7 * month.dayInMonth }}
        >
            {isRenderDays &&
                month.days.map((day, i) => (
                    <div
                        className={classNames(cls.day, {
                            [cls.factWrapper]: isPlanFact,
                            [cls.nowDate]: day.date === nowDate,
                        })}
                        key={day.date + i + charter.guid}
                    >
                        {day.date === charterDate && (
                            <CharterItem isPlanFact={isPlanFact} charter={charter} />
                        )}
                    </div>
                ))}
        </div>
    );
};
